import React from 'react'
import PropTypes from 'prop-types'
import Switch from 'react-toggle-switch'
import './style.css'

class NRTToggleSwitch extends React.Component {

    state = {
        switched: false,
    }


    componentDidMount() {
        this.setState({
            switched: this.props.value
        })
    }


    setValue = (value) => {
        this.setState({
                switched: value
            },
            () => {
               // this.props.onChange(value)
            })
    }




    handleChange = () => {
        const switched = this.state.switched

        this.setState({
            switched: !switched
        })

        this.props.onChange(!switched)
    }


    render() {

        const {secondary} = this.props

        const cls = secondary ? 'secondary' : 'primary'

        return (
            <Switch
                onClick={this.handleChange}
                on={this.state.switched}
                className={`nrt-${cls}-switch`}
            />
        )
    }
}

NRTToggleSwitch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    secondary: PropTypes.bool,
}

NRTToggleSwitch.defaultProps = {
    secondary: false,
}

export default NRTToggleSwitch



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/ToggleSwitchInput/index.js